module.exports = __webpack_public_path__ + "img/MyPace.f24d3983.png";